import { FC, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { Box, CircularProgress } from '@mui/material';
import { useAuthContext } from 'common/contexts/AuthContext';
import { ErrorBoundary } from 'common/hocs/ErrorBoundary';

import { PrivateElement } from './PrivateElement';
import { RouteDefinition, routes } from './Routes';

export const AppRoutes: FC = () => {
    const { isAuthenticated, currentUserRoles, rolesChecked } = useAuthContext();

    function renderRoutes(routesToRender: RouteDefinition[], parentPath = '') {
        return routesToRender.map(({ path, roles, element, children }, index) => {
            const fullPath = parentPath + (path ?? `index-${index}`);
            const routeProps = {
                element: roles
                    ? <PrivateElement
                        roles={roles}
                        element={element}
                        isAuthenticated={isAuthenticated}
                        currentUserRoles={currentUserRoles}
                        rolesChecked={rolesChecked}/>
                    : element
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } as any;

            if (path) {
                routeProps.path = path;
            } else {
                routeProps.index = true;
            }

            return (
                <Route key={fullPath} {...routeProps}>
                    {children && renderRoutes(children || [], fullPath + '/')}
                </Route>
            );
        });
    }

    return (
        <div>
            {isAuthenticated && rolesChecked && (
                <Suspense fallback={
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '200px' }}>
                        <CircularProgress />
                    </Box>
                }>
                    <Routes>
                        {renderRoutes(routes)}
                    </Routes>
                </Suspense>
            )}
            {!isAuthenticated && !rolesChecked && (
                <ErrorBoundary>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <CircularProgress />
                        <p>Authenticating...</p>
                    </Box>
                </ErrorBoundary>
            )}
            {isAuthenticated && !rolesChecked && (
                <ErrorBoundary>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <CircularProgress />
                        <p>Checking roles...</p>
                    </Box>
                </ErrorBoundary>
            )}
        </div>
    );
};
